/* =========================================================
   SMA Product Extensions (munchaloo)
   Carousel engine for the Testimonial + Buy Also blocks.
   Features: pixel-accurate slide stepping, pagination dots,
   autoplay (default 5s) that starts ONLY when the carousel
   enters the viewport, and pointer/touch swipe.
   ========================================================= */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.cxInit === 'true') return;
    root.dataset.cxInit = 'true';

    var viewport = root.querySelector('.sma-cx__viewport');
    var track = root.querySelector('.sma-cx__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.sma-cx__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sma-dot'));
    if (!viewport || !track || slides.length === 0) return;

    var index = 0;
    var autoplayMs = parseInt(root.dataset.autoplayMs || '5000', 10);
    var timer = null;
    var inView = false;

    function maxScroll() {
      // viewport.clientWidth includes its horizontal padding (4px each side, added so
      // slide box-shadows aren't clipped). The track lives in the padding-box content
      // area, so the true scrollable distance must subtract that padding — otherwise the
      // clamp stops ~8px short and the final slide gets clipped on the right.
      var cs = window.getComputedStyle(viewport);
      var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      return Math.max(0, track.scrollWidth - (viewport.clientWidth - padX));
    }

    function offsetFor(i) {
      // Position of slide i relative to the track, clamped so the track's
      // right edge never scrolls past the viewport's right edge.
      var raw = slides[i].offsetLeft - track.offsetLeft;
      return Math.min(raw, maxScroll());
    }

    function render() {
      track.style.transform = 'translateX(' + -offsetFor(index) + 'px)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
        dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
      }
    }

    function go(i) {
      var total = slides.length;
      index = ((i % total) + total) % total;
      render();
    }
    function next() { go(index + 1); }

    function start() {
      stop();
      if (autoplayMs > 0 && inView && slides.length > 1) {
        timer = setInterval(next, autoplayMs);
      }
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // ----- Dots -----
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        go(i);
        start();
      });
    });

    // ----- Pause on hover (desktop) + tab visibility -----
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // ----- Swipe / drag -----
    var dragging = false;
    var startX = 0;
    var baseOffset = 0;
    var moved = 0;

    function pointerDown(e) {
      if (slides.length <= 1) return;
      dragging = true;
      moved = 0;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      baseOffset = offsetFor(index);
      root.classList.add('is-dragging');
      stop();
    }
    function pointerMove(e) {
      if (!dragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      moved = x - startX;
      var target = baseOffset - moved;
      target = Math.max(0, Math.min(target, maxScroll()));
      track.style.transform = 'translateX(' + -target + 'px)';
    }
    function pointerUp() {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      var threshold = 40;
      if (moved <= -threshold) {
        go(index + 1);
      } else if (moved >= threshold) {
        go(index - 1);
      } else {
        render();
      }
      start();
    }

    viewport.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);
    viewport.addEventListener('touchstart', pointerDown, { passive: true });
    viewport.addEventListener('touchmove', pointerMove, { passive: true });
    viewport.addEventListener('touchend', pointerUp);

    // Prevent click-through after a drag (e.g. on product card links)
    viewport.addEventListener('click', function (e) {
      if (Math.abs(moved) > 5) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    // Keep position correct on resize
    window.addEventListener('resize', render);

    // ----- Autoplay starts only when in viewport -----
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) start(); else stop();
        });
      }, { threshold: 0.25 });
      io.observe(root);
    } else {
      inView = true;
      start();
    }

    render();
  }

  function init(scope) {
    (scope || document).querySelectorAll('.sma-cx').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) init(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target) init(e.target);
  });
})();
/* =========================================================
   SMA Desktop Gallery Arrows
   Drives the prev / next arrows overlaid on the main product
   image (desktop). Reuses the theme's media-gallery custom
   element (setActiveMedia) so thumbnails stay in sync.
   No loop: the prev arrow is disabled on the first image and
   the next arrow on the last.
   ========================================================= */
(function () {
  'use strict';

  function mediaItems(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return [];
    return Array.prototype.slice.call(
      viewer.querySelectorAll('.product__media-item[data-media-id]')
    );
  }

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function syncArrows(gallery) {
    var list = mediaItems(gallery);
    var idx = activeIndex(list);
    var prev = gallery.querySelector('.sma-gallery-arrow--prev');
    var next = gallery.querySelector('.sma-gallery-arrow--next');
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= list.length - 1;
  }

  function move(gallery, dir) {
    var list = mediaItems(gallery);
    if (!list.length) return;
    var target = activeIndex(list) + dir;
    if (target < 0 || target >= list.length) return; /* no wrap-around */
    var mediaId = list[target].dataset.mediaId;
    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, false);
    } else {
      /* Fallback: click the matching thumbnail if the custom element
         method isn't available for any reason. */
      var thumb = gallery.querySelector('[data-target="' + mediaId + '"] button');
      if (thumb) thumb.click();
    }
    syncArrows(gallery);
  }

  function initGallery(gallery) {
    if (gallery.dataset.smaArrowsInit === 'true') return;
    var prev = gallery.querySelector('.sma-gallery-arrow--prev');
    var next = gallery.querySelector('.sma-gallery-arrow--next');
    if (!prev && !next) return;
    gallery.dataset.smaArrowsInit = 'true';

    if (prev) prev.addEventListener('click', function () { move(gallery, -1); });
    if (next) next.addEventListener('click', function () { move(gallery, 1); });

    /* Keep arrow enable/disable state in sync when the active image
       changes by other means (thumbnail click, mobile swipe). */
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', function () { syncArrows(gallery); });
    }
    gallery.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.thumbnail-list__item')) {
        window.setTimeout(function () { syncArrows(gallery); }, 0);
      }
    });

    syncArrows(gallery);
  }

  function initArrows(scope) {
    (scope || document).querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initArrows(); });
  } else {
    initArrows();
  }

  /* Re-init after the section is re-rendered (theme editor, variant change). */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initArrows(e.target);
  });
})();

/* =========================================================
   Bundle Builder (SMA) — block `sma_bundle_builder`
   Multi-select pill groups on bundle PDPs. Selections are
   written into hidden inputs named properties[<cart label>]
   which are form-associated with the product form via the
   `form` attribute, so Shopify carries them into the cart,
   the checkout and the order (admin + customer).
   ========================================================= */
(function () {
  'use strict';

  function fillTokens(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function initBundle(root) {
    if (!root || root.dataset.smaBundleInit === 'true') return;
    root.dataset.smaBundleInit = 'true';

    var counterTpl = root.dataset.counterText || '{selected} of {required} selected';
    var errorTpl = root.dataset.errorText || 'Pick {remaining} more to continue';
    var enforce = root.dataset.enforce === 'true';
    var allowRepeats = root.dataset.allowRepeats === 'true';
    var formId = root.dataset.formId || '';
    var productInfo = root.closest('product-info') || document;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sma-bundle-group]'));
    if (groups.length === 0) return;

    /* Set while WE toggle the submit button, so the MutationObserver
       below ignores our own writes and only reacts to Dawn's. */
    var selfWrite = false;

    function submitButton() {
      var form = formId ? document.getElementById(formId) : null;
      if (form) {
        var inForm = form.querySelector('.product-form__submit');
        if (inForm) return inForm;
      }
      return productInfo.querySelector ? productInfo.querySelector('.product-form__submit') : null;
    }

    /* How many of this option are in the box: 0 when not picked,
       otherwise its stored count (1 unless repeats bumped it). */
    function pillQty(pill) {
      if (!pill.classList.contains('is-selected')) return 0;
      var qty = parseInt(pill.dataset.qty || '1', 10);
      return qty > 0 ? qty : 1;
    }

    function groupTotal(group) {
      return Array.prototype.slice
        .call(group.querySelectorAll('[data-sma-bundle-pill]'))
        .reduce(function (sum, pill) { return sum + pillQty(pill); }, 0);
    }

    function setQty(pill, qty) {
      if (qty <= 0) {
        pill.classList.remove('is-selected');
        pill.setAttribute('aria-pressed', 'false');
        delete pill.dataset.qty;
      } else {
        pill.classList.add('is-selected');
        pill.setAttribute('aria-pressed', 'true');
        pill.dataset.qty = String(qty);
      }
    }

    function renderGroup(group) {
      var required = parseInt(group.dataset.required || '0', 10) || 0;
      var pills = Array.prototype.slice.call(group.querySelectorAll('[data-sma-bundle-pill]'));
      var chosen = pills.filter(function (pill) { return pill.classList.contains('is-selected'); });
      var total = groupTotal(group);
      var complete = total >= required;
      var full = required > 0 && total >= required;

      /* Cart value: "Masala Punch x2, Tandoori Twist" */
      var input = group.querySelector('[data-sma-bundle-input]');
      if (input) {
        input.value = chosen
          .map(function (pill) {
            var qty = pillQty(pill);
            return (pill.dataset.value || '') + (qty > 1 ? ' x' + qty : '');
          })
          .join(', ');
      }

      var counter = group.querySelector('[data-sma-bundle-counter]');
      if (counter) {
        counter.textContent = fillTokens(counterTpl, {
          selected: total,
          required: required
        });
      }

      group.classList.toggle('is-complete', complete && required > 0);

      /* Once the required count is reached the unpicked options lock out. */
      pills.forEach(function (pill) {
        var locked = full && !pill.classList.contains('is-selected');
        pill.classList.toggle('is-disabled', locked);
        pill.setAttribute('aria-disabled', locked ? 'true' : 'false');

        /* Repeat stepper: visible on picked options; + locks when full. */
        var option = pill.closest('[data-sma-bundle-option]');
        var stepper = option ? option.querySelector('[data-sma-bundle-stepper]') : null;
        if (!stepper) return;
        var selected = pill.classList.contains('is-selected');
        stepper.hidden = !(allowRepeats && selected);
        var qtyEl = stepper.querySelector('[data-sma-bundle-qty]');
        if (qtyEl) qtyEl.textContent = pillQty(pill) || 1;
        var plus = stepper.querySelector('[data-sma-bundle-step="plus"]');
        if (plus) plus.disabled = full;
      });

      var errorEl = group.querySelector('[data-sma-bundle-error]');
      if (errorEl) {
        if (group.dataset.showError === 'true' && !complete) {
          errorEl.textContent = fillTokens(errorTpl, {
            remaining: required - total,
            required: required,
            group: group.dataset.groupName || ''
          });
          errorEl.hidden = false;
        } else {
          errorEl.hidden = true;
        }
      }

      return complete;
    }

    function isComplete() {
      var complete = true;
      groups.forEach(function (group) {
        if (!renderGroup(group)) complete = false;
      });
      return complete;
    }

    function applyLock() {
      var complete = isComplete();
      root.classList.toggle('sma-bundle--incomplete', !complete);
      if (productInfo.classList) {
        productInfo.classList.toggle('sma-bundle-locked', enforce && !complete);
      }

      if (!enforce) return complete;

      var button = submitButton();
      if (button) {
        selfWrite = true;
        if (!complete) {
          button.setAttribute('disabled', 'disabled');
          button.dataset.smaBundleDisabled = 'true';
        } else if (button.dataset.smaBundleDisabled === 'true') {
          /* Only re-enable a button WE disabled — never one Dawn disabled
             because the variant is sold out or unavailable. */
          delete button.dataset.smaBundleDisabled;
          button.removeAttribute('disabled');
        }
        window.setTimeout(function () { selfWrite = false; }, 0);
      }
      return complete;
    }

    root.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      /* − / + on a picked option */
      var step = event.target.closest('[data-sma-bundle-step]');
      if (step && root.contains(step)) {
        if (step.disabled) return;
        var option = step.closest('[data-sma-bundle-option]');
        var stepPill = option ? option.querySelector('[data-sma-bundle-pill]') : null;
        var stepGroup = step.closest('[data-sma-bundle-group]');
        if (!stepPill || !stepGroup) return;
        var required = parseInt(stepGroup.dataset.required || '0', 10) || 0;
        var qty = pillQty(stepPill);
        if (step.dataset.smaBundleStep === 'plus') {
          if (required > 0 && groupTotal(stepGroup) >= required) return;
          setQty(stepPill, qty + 1);
        } else {
          setQty(stepPill, qty - 1);
          /* Dropped to zero: the stepper hides, so hand focus to the option. */
          if (qty - 1 <= 0) stepPill.focus();
        }
        if (stepGroup.dataset.showError === 'true') stepGroup.dataset.showError = 'false';
        applyLock();
        return;
      }

      var pill = event.target.closest('[data-sma-bundle-pill]');
      if (!pill || !root.contains(pill)) return;
      if (pill.classList.contains('is-disabled')) return;

      setQty(pill, pill.classList.contains('is-selected') ? 0 : 1);

      var group = pill.closest('[data-sma-bundle-group]');
      if (group && group.dataset.showError === 'true') {
        group.dataset.showError = 'false';
      }
      applyLock();
    });

    /* Last line of defence: a capture listener on the document runs before
       product-form.js's own submit handler on the form element. */
    document.addEventListener(
      'submit',
      function (event) {
        if (!enforce) return;
        var submitTarget = event.target;
if (!formId || !submitTarget || !submitTarget.getAttribute || submitTarget.getAttribute('id') !== formId) return;
        if (isComplete()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        groups.forEach(function (group) { group.dataset.showError = 'true'; });
        applyLock();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    /* Dawn re-enables the submit button whenever the variant changes, so
       re-assert the lock after it does. */
    var button = submitButton();
    if (enforce && button && window.MutationObserver) {
      new MutationObserver(function () {
        if (selfWrite) return;
        applyLock();
      }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
    }
    if (productInfo.addEventListener) {
      productInfo.addEventListener('change', function () {
        window.setTimeout(applyLock, 0);
      });
    }

    applyLock();
  }

  function initBundles(scope) {
    (scope || document).querySelectorAll('[data-sma-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initBundles(); });
  } else {
    initBundles();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initBundles(event.target);
  });
})();

/* =========================================================
   SMA Pack Builder  (main-product block: sma_pack_builder)
   ---------------------------------------------------------
   The product's variants are box sizes. The shopper adds
   products with Add / − / +; the total number of packs picks
   the variant whose custom.pack_count matches (see the JSON
   config rendered by the block).

   Variant switch, two layers:
   1. The form's input[name="id"] is set straight away, so an
      instant tap on Add to cart already sends the right box.
   2. The (hidden) Dawn variant picker is set and a `change`
      is dispatched, so product-info.js refreshes the price,
      sold-out state, URL and media exactly as it would for a
      manual pick — and the sticky ATC follows along.

   Box contents are written into a hidden input named
   properties[<cart label>], form-associated with the product
   form, so they reach the cart, checkout and the order.

   Add to cart stays locked (flagged with
   data-sma-bundle-disabled, which sma-sticky-atc.js already
   understands) until the pack count matches an in-stock
   variant.
   ========================================================= */
(function () {
  'use strict';

  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initPack(root) {
    if (!root || root.dataset.smaPackInit === 'true') return;

    var configEl = root.querySelector('[data-sma-pack-config]');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }
    var tiers = Array.isArray(config.tiers) ? config.tiers : [];
    if (tiers.length === 0) return;
    root.dataset.smaPackInit = 'true';

    var byCount = {};
    tiers.forEach(function (tier) { byCount[tier.count] = tier; });
    var min = config.min || tiers[0].count;
    var max = config.max || tiers[tiers.length - 1].count;

    var formId = root.dataset.formId || '';
    var enforce = root.dataset.enforce === 'true';
    var productInfo = root.closest('product-info') || document;
    var items = toArray(root.querySelectorAll('[data-sma-pack-item]'));
    var tierEls = toArray(root.querySelectorAll('[data-sma-pack-tier]'));
    var input = root.querySelector('[data-sma-pack-input]');
    var countEl = root.querySelector('[data-sma-pack-count]');
    var totalEl = root.querySelector('[data-sma-pack-total]');
    var msgEl = root.querySelector('[data-sma-pack-msg]');
    var itemFormat = root.dataset.itemFormat || '{qty} × {title}';

    var showError = false;
    /* Set while WE toggle the submit button, so the MutationObserver
       below ignores our own writes and only reacts to Dawn's. */
    var selfWrite = false;

    function qtyOf(item) {
      return parseInt(item.dataset.qty || '0', 10) || 0;
    }

    function totalPacks() {
      return items.reduce(function (sum, item) { return sum + qtyOf(item); }, 0);
    }

    function currentTier() {
      return byCount[totalPacks()] || null;
    }

    function isValid() {
      var tier = currentTier();
      return !!(tier && tier.available);
    }

    function productForm() {
      return formId ? document.getElementById(formId) : null;
    }

    function submitButton() {
      var form = productForm();
      if (form) {
        var inForm = form.querySelector('.product-form__submit');
        if (inForm) return inForm;
      }
      return productInfo.querySelector ? productInfo.querySelector('.product-form__submit') : null;
    }

    function contentsText() {
      return items
        .filter(function (item) { return qtyOf(item) > 0; })
        .map(function (item) {
          return fill(itemFormat, { qty: qtyOf(item), title: item.dataset.title || '' });
        })
        .join(', ');
    }

    function render() {
      var count = totalPacks();
      var full = count >= max;
      var tier = currentTier();

      items.forEach(function (item) {
        var qty = qtyOf(item);
        var soldOut = item.dataset.available !== 'true';
        var add = item.querySelector('[data-sma-pack-add]');
        var stepper = item.querySelector('[data-sma-pack-stepper]');
        var qtyEl = item.querySelector('[data-sma-pack-qty]');
        var plus = item.querySelector('[data-sma-pack-plus]');

        item.classList.toggle('is-added', qty > 0);
        if (add) {
          add.hidden = qty > 0;
          add.disabled = soldOut || full;
        }
        if (stepper) stepper.hidden = qty === 0;
        if (qtyEl) qtyEl.textContent = String(qty);
        if (plus) plus.disabled = full;
      });

      tierEls.forEach(function (el, index) {
        var tierCount = parseInt(el.dataset.count, 10) || 0;
        var nextEl = tierEls[index + 1];
        var nextCount = nextEl ? parseInt(nextEl.dataset.count, 10) || 0 : Infinity;
        el.classList.toggle('is-reached', count >= tierCount);
        el.classList.toggle('is-next-reached', count >= nextCount);
        el.classList.toggle('is-active', count === tierCount);
      });

      root.classList.toggle('is-full', full);
      root.classList.toggle('is-empty', count === 0);

      var tokens = { count: count, max: max, min: min };
      if (countEl) countEl.textContent = fill(root.dataset.summaryText, tokens);
      if (totalEl) {
        totalEl.textContent = tier ? tier.total : '';
        totalEl.hidden = !tier;
      }

      var message = '';
      var isError = false;
      if (count === 0) {
        if (showError) {
          message = root.dataset.errorText;
          isError = true;
        }
      } else if (count < min) {
        message = root.dataset.errorText;
        isError = true;
      } else if (!tier || !tier.available) {
        message = root.dataset.unavailableText;
        isError = true;
      } else if (full) {
        message = root.dataset.fullText;
      }
      if (msgEl) {
        msgEl.textContent = fill(message, tokens);
        msgEl.hidden = !message;
        msgEl.classList.toggle('is-error', isError);
      }

      if (input) input.value = contentsText();
    }

    /* Tick the matching option in Dawn's variant picker (radio pills
       or dropdown) and let variant-selects publish the change. */
    function selectOptions(selects, names) {
      var groups = toArray(selects.querySelectorAll('.product-form__input'));
      var changed = null;
      (names || []).forEach(function (name, index) {
        var group = groups[index];
        if (!group) return;
        var select = group.querySelector('select');
        if (select) {
          var hasOption = toArray(select.options).some(function (option) { return option.value === name; });
          if (hasOption && select.value !== name) {
            select.value = name;
            changed = select;
          }
          return;
        }
        toArray(group.querySelectorAll('input[type="radio"]')).forEach(function (radio) {
          if (radio.value === name && !radio.checked) {
            radio.checked = true;
            changed = radio;
          }
        });
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
      return !!changed;
    }

    function syncVariant() {
      var tier = currentTier();
      if (!tier) return;

      var form = productForm();
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var idChanged = !!idInput && String(idInput.value) !== String(tier.id);
      if (idInput) {
        if (idChanged) idInput.value = tier.id;
        if (tier.available) idInput.disabled = false;
      }

      var selects = productInfo.querySelector ? productInfo.querySelector('variant-selects') : null;
      if (selects && selectOptions(selects, tier.options)) return;

      /* No picker on the page (or it already shows this variant):
         still tell listeners such as the sticky ATC that the id moved. */
      if (idChanged) idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function applyLock() {
      var valid = isValid();
      root.classList.toggle('sma-pack--locked', !valid);
      if (productInfo.classList) {
        productInfo.classList.toggle('sma-pack-locked', enforce && !valid);
      }
      if (!enforce) return valid;

      var button = submitButton();
      if (button) {
        selfWrite = true;
        if (!valid) {
          button.setAttribute('disabled', 'disabled');
          button.dataset.smaBundleDisabled = 'true';
        } else if (button.dataset.smaBundleDisabled === 'true') {
          /* Only re-enable a button WE disabled — never one Dawn disabled
             because the variant is sold out or still loading. */
          delete button.dataset.smaBundleDisabled;
          button.removeAttribute('disabled');
        }
        window.setTimeout(function () { selfWrite = false; }, 0);
      }
      return valid;
    }

    function update() {
      render();
      syncVariant();
      applyLock();
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest
        ? event.target.closest('[data-sma-pack-add], [data-sma-pack-plus], [data-sma-pack-minus]')
        : null;
      if (!button || !root.contains(button) || button.disabled) return;
      var item = button.closest('[data-sma-pack-item]');
      if (!item) return;

      var qty = qtyOf(item);
      var isMinus = button.hasAttribute('data-sma-pack-minus');
      if (isMinus) {
        qty = Math.max(0, qty - 1);
      } else {
        if (totalPacks() >= max || item.dataset.available !== 'true') return;
        qty += 1;
      }
      item.dataset.qty = String(qty);
      showError = false;
      update();

      /* Keep keyboard focus on a control that still exists. */
      if (button.hasAttribute('data-sma-pack-add')) {
        var plus = item.querySelector('[data-sma-pack-plus]');
        if (plus && !plus.disabled) plus.focus();
        else {
          var minus = item.querySelector('[data-sma-pack-minus]');
          if (minus) minus.focus();
        }
      } else if (isMinus && qty === 0) {
        var add = item.querySelector('[data-sma-pack-add]');
        if (add) add.focus();
      }
    });

    /* Last line of defence: a capture listener on the document runs before
       product-form.js's own submit handler on the form element. */
    document.addEventListener(
      'submit',
      function (event) {
        if (!root.isConnected) return;
        /* getAttribute, not .id — the product form contains <input name="id">,
           which shadows form.id and would make this check never match. */
        var target = event.target;
        if (!formId || !target || !target.getAttribute || target.getAttribute('id') !== formId) return;
        render();
        if (!enforce || isValid()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showError = true;
        render();
        applyLock();
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      true
    );

    /* Dawn re-enables the submit button when a variant finishes loading,
       so re-assert the lock after it does. */
    var lockButton = submitButton();
    if (enforce && lockButton && window.MutationObserver) {
      new MutationObserver(function () {
        if (selfWrite || !root.isConnected) return;
        applyLock();
      }).observe(lockButton, { attributes: true, attributeFilter: ['disabled'] });
    }
    if (productInfo.addEventListener) {
      productInfo.addEventListener('change', function () {
        window.setTimeout(applyLock, 0);
      });
    }

    render();
    applyLock();
  }

  function initPacks(scope) {
    (scope || document).querySelectorAll('[data-sma-pack]').forEach(initPack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initPacks(); });
  } else {
    initPacks();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initPacks(event.target);
  });
})();
